// Components/Modals/AddPolicyModal.jsx
import React, { useState } from 'react';
import USStatesDropdown from '../Shared/USStatesDropdown';

const AddEntityPolicyModal = ({ isOpen, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        polNo: '',
        entityName: '',
        state: '',
        zip: '',
        fullTIN: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="baseHeader">Add Policy</h3>
                <form onSubmit={handleSubmit} className="baseForm">
                    <label className="baseLabel">Policy Number</label>
                    <input className="baseInput" name="polNo" value={formData.polNo} onChange={handleChange} required />

                    <label className="baseLabel">Entity Name</label>
                    <input className="baseInput" name="entityName" value={formData.entityName} onChange={handleChange} required />

                    <label className="baseLabel">State</label>
                    <USStatesDropdown name="state" value={formData.state} onChange={handleChange} required/>

                    <label className="baseLabel">Zip</label>
                    <input className="baseInput" name="zip" value={formData.zip} onChange={handleChange} maxLength={9} required />

                    <label className="baseLabel">Full TIN</label>
                    <input className="baseInput" name="fullTIN" value={formData.fullTIN} onChange={handleChange} maxLength={9} required />

                    <button type="submit" className="baseButton">Submit</button>
                    <button type="button" className="baseButton secondary" onClick={onClose}>Cancel</button>
                </form>
            </div>
        </div>
    );
};

export default AddEntityPolicyModal;
